export const HOURS_PER_YEAR = 8760;
export const HOURS_PER_LEAP_YEAR = 8784;
